import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import logo from '../../logos/storage-sprint.png';

const ReviewPendingPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 py-12">
            <Helmet>
                <title>Account Review Pending | Storage Sprint</title>
            </Helmet>

            <div className="max-w-md w-full bg-white rounded-xl shadow-md p-8 text-center">
                <img
                    src={logo}
                    alt="Storage Sprint Logo"
                    className="mx-auto mb-6 w-24 h-auto"
                />

                <h1 className="text-2xl font-bold text-gray-800 mb-4">
                    Your account
                    <span className="text-yellow-500"> is under review</span>
                </h1>

                <p className="text-gray-600 mb-6">
                    Thank you for registering as a driver with Storage Sprint. Your account is currently being reviewed by our team. Once approved, you will be able to access all driver features.
                </p>
                <p className="text-gray-600 mb-8">
                    In the meantime, feel free to explore our services and learn more about how Storage Sprint works.
                </p>

                <button
                    onClick={() => navigate('/')}
                    className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-lg transition"
                >
                    Explore Storage Sprint
                </button>
            </div>
        </div>
    );
};

export default ReviewPendingPage;
